import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AppModule } from "../app.module";
import { MapSelect } from "../map/map-select/map-select";
import { Incident, IncidentLocation, NearbyServiceProvider } from '../models/incident';
import { IncidentService } from '../shared/incident.service';
import { SharedDataService } from '../shared/shareddata.service';

@Component({
  selector: 'app-fleet-incident',
  imports: [AppModule, MapSelect],
  templateUrl: './fleet-incident.html',
  styleUrl: './fleet-incident.less'
})
export class FleetIncident implements OnInit {

  incidentLocation: IncidentLocation | null = null;
  nearbyServiceProviders: NearbyServiceProvider | null = null;

  todayRescues: number = 0;
  avgResponseTime: string = '--';

  isLoading = signal<boolean>(false);

  constructor(private router: Router, private incidentService: IncidentService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
      this.findLocation();
      this.loadFooterStats();
  }


  public findLocation() {
    this.isLoading.set(true);
    window.navigator.geolocation.getCurrentPosition((position) => {
      this.incidentLocation = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        descriptionShort: '',
        description: position.coords.latitude.toFixed(4) + ', ' + position.coords.longitude.toFixed(4)
      };
      this.isLoading.set(false);
    }, (error) => {
      console.error('Geolocation error:', error);
      this.isLoading.set(false);
    });
  }

public onLocationSelected(location: IncidentLocation): void {
  this.nearbyServiceProviders = null;
    this.incidentLocation = {
      latitude: location.latitude,
      longitude: location.longitude,
      descriptionShort: location.descriptionShort,
      description: location.description
    };
    this.onProceed();
  }

  public onProceed(): void {
    this.isLoading.set(true);
    const location = this.incidentLocation;
    if (!location) {
      this.isLoading.set(false);
      return;
    }
    this.incidentService.findNearbyServiceProviders(location.latitude, location.longitude).subscribe({
      next: (data) => {
        this.nearbyServiceProviders = data;
      },
      error: (error) => {
        console.error('Error fetching nearby service providers:', error);
      },
      complete: () => {
        this.isLoading.set(false);
      }
    });
  }

  public onRequestHelp(): void {
  const location = this.incidentLocation;
  if (location) {
    // Store the breakdown location in localStorage
    localStorage.setItem('breakdownLocation', JSON.stringify({
      latitude: location.latitude,
      longitude: location.longitude,
      description: location.description,
      descriptionShort: location.descriptionShort,
      timestamp: new Date().toISOString()
    }));
    this.sharedDataService.newIncident = new Incident();
    this.sharedDataService.newIncident.location = location;
    this.router.navigate(['/incident','new']);
    //console.log("Breakdown location stored in browser memory");
    
    // TODO: Navigate to next step or show confirmation
    // this.router.navigate(['/request-help']);
  } else {
    console.error("No location selected");
  }
}

  public onClientLogin(): void {
    this.router.navigate(['/login']);
  }

  public getDisplayRanges(): Array<{distance: number, count: number}> {
    const sp = this.nearbyServiceProviders;
    if (!sp) return [];

    const ranges = [
      { distance: 25, count: sp.within25km },
      { distance: 50, count: sp.within50km },
      { distance: 75, count: sp.within75km },
      { distance: 100, count: sp.within100km },
      { distance: 150, count: sp.within150km },
      { distance: 200, count: sp.within200km },
      { distance: 250, count: sp.within250km }
    ];

    const result: Array<{distance: number, count: number}> = [];
    
    const firstRange = ranges.find(r => r.count > 0);
    if (firstRange) {
      result.push(firstRange);
      
      if (firstRange.count < 3) {
        const nextRange = ranges.find(r => r.distance > firstRange.distance && r.count > 0);
        if (nextRange) {
          result.push(nextRange);
        }
      }
    }
    
    return result;
  }

  private loadFooterStats(): void {
    // TODO: Replace with actual API call
    // Example:
    this.todayRescues = 147;
    this.avgResponseTime = '23 min';
  }

  public isNoNearbyProviders(): boolean {
    const sp = this.nearbyServiceProviders;
    return sp !== null && sp.within25km === 0 && sp.within50km === 0 && sp.within75km === 0 &&
           sp.within100km === 0 && sp.within150km === 0 && sp.within200km === 0 && sp.within250km === 0;
  }
}